import AppBaseStore from './baseStore'
import { useDjango } from '@/composables/useDjango'
import type { BaseStoreActions, BaseStoreType } from '@/types/storeTypes'
import API from '@/api/apiUrls'
import type { SelectedVisualizationColumn } from '@/stores/type/selectedVisualizationColumn'
import { useProjectStore } from '@/stores/project'

const { api } = useDjango()

type State = BaseStoreType<SelectedVisualizationColumn>

const baseUrl = API.BOREHOLE_DATA.SELECTED_VISUALIZATION_COLUMN.INDEX
const baseStore: BaseStoreType<SelectedVisualizationColumn> = new AppBaseStore(
  baseUrl,
  api,
  null,
  'id'
)
const baseStoreActions: BaseStoreActions<SelectedVisualizationColumn> = baseStore.actions
export const useSelectedVisualizationColumnStore = defineStore({
  id: 'selectedVisualizationColumn',
  state: (): State => ({
    ...baseStore.state,
    rawSelectedColumns: []
  }),
  actions: {
    ...baseStoreActions,
    resetAll() {
      this.$reset()
    },
    async bulkCreate(columns: SelectedVisualizationColumn[]) {
      const projectStore = useProjectStore()
      const currentProjectId = projectStore.currentItem?.id
      if (!currentProjectId) {
        return
      }
      const urlParameters = new URLSearchParams({
        project_user__project_id: currentProjectId
      })
      const url = `${baseUrl}?${urlParameters.toString()}`
      try {
        this.writeLoading = true
        const apiService = api.service(baseUrl)
        const responseData = await apiService.apiService.api(url, 'POST', columns)
        this.items.push(...responseData)
      } catch (e) {
        this.setSnackbarMessage('Bulk create items failed.', 'error')
        console.error(e)
      } finally {
        this.writeLoading = false
      }
    }
  },
  getters: {
    ...baseStore.getters
  }
})
